import * as yup from "yup";

const ALLOWED_TOKENS = ["YYYY", "YY", "MM", "DD", "ID"];
const TOKEN_REGEX = /\{([^}]+)\}/g;

export const OFFER_SALE_EDIT_FORM_SCHEMA = yup.object().shape({
  offerSaleFormatNumber: yup
    .string()
    .required("Molimo Vas da unesete format broja ponude")

    .test(
      "only-allowed-tokens",
      "Dozvoljeni su samo tokeni: {YYYY}, {YY}, {MM}, {DD}, {ID}",
      (value) => {
        if (!value) return false;

        let match;
        TOKEN_REGEX.lastIndex = 0;
        let hasToken = false;

        while ((match = TOKEN_REGEX.exec(value)) !== null) {
          hasToken = true;

          // ❌ sve što nije whitelistano
          if (!ALLOWED_TOKENS.includes(match[1])) {
            return false;
          }
        }

        // mora postojati barem jedan validan token
        return hasToken;
      }
    ),
});
